/**
 * Recursively wrap an object as readonly at every level.
 *
 * This can be expensive for TSC to check, so use sparingly.
 *
 * Via https://github.com/microsoft/TypeScript/issues/13923#issuecomment-488160343.
 */
export type DeepReadonly<T> = T extends Function
  ? T
  : T extends ReadonlyArray<infer R>
  ? ReadonlyArray<DeepReadonly<R>>
  : T extends Map<infer K, infer V>
  ? ReadonlyMap<DeepReadonly<K>, DeepReadonly<V>>
  : T extends object
  ? { readonly [P in keyof T]: DeepReadonly<T[P]> }
  : T;
